import api from "./api";

export interface SalaryCalculationResponse {
  results: SalaryRecord[];
}

export interface SalaryRecord {
  salary_id: number;
  employee_id: string;
  employeeID: string;
  name: string;
  calculationType: string;
  mode: string;
  status: string;
  department: string;
  designation: string;
  joiningDate: string;
  SalaryDate: string;
  month: number;
  year: number;
  monthlySalary: number;
  netSalary: number;
  bonus: number;
  extrapay: number;
  deductions: number;
  isApproved: boolean;
  approvedBy: string | null;
  approvedAt: string | null;
  createdAt: string;
  updatedAt: string;
  logs?: {
    attendance: DailyBreakdown[];
  };

}

export interface DailyBreakdown {
  date: string;
  hours: number;
  status: string;
  payable: number;
  overtime: number;
  day_salary: number;
  overtime_amount: number;
}

export interface ApprovalRequest {
  id: string[];
  year: number;
  month: number;
}

export interface ApprovalResponse {
  success: boolean;
  message: string;
  results?: SalaryRecord[];
  data?: SalaryRecord;
}

export interface SalaryStatusResponse {
  success: boolean;
  status: {
    pending: number;
    approved: number;
    rejected: number;
    total: number;
  };
  results?: SalaryRecord[];
}

export interface ManualSalaryAdjustment {
  employee_id: string;
  bonus: number;
  extrapay: number;
  month: number;
  year: number;
  description?: string;
}

export interface ExportEmployeesResponse {
  success: boolean;
  message: string;
  data?: any;
  download_url?: string;
}

export interface ExportSalaryResponse {
  success: boolean;
  message: string;
  data?: any;
  download_url?: string;
}


export const salaryApi = {
  // Salary settings for the current branch — includes the holiday calendar.
  getSettings: () => api.get('/salary/get_salary_settings'),

  // Original attendance-based calculation
  calculateBulk: (year: string, month: string, employeeIds: string[]) => {
    return api.post(`/salary/calculate/bulk?year=${year}&month=${month}`, {
      id: employeeIds
    });
  },

  // New system-level tracking calculation
  calculateWithSystemTracking: (year: string, month: string, employeeIds: string[]) => {
    return api.post(`/salary/calculate/bulk/system-tracking?year=${year}&month=${month}`, {
      id: employeeIds
    });
  },

  manualSalaryAdjustment: (data: ManualSalaryAdjustment) => {
    return api.put('/salary/manual_salary_adjustment', data);
  },

  // No Deduction - Attendance Based
calculateNoDeduction: (year: string, month: string, employeeIds: string[]) => {
  return api.post(
    `/salary/re-calculate_no_deduction?year=${year}&month=${month}`,
    { id: employeeIds }
  );
},

// No Deduction - System Tracking
calculateNoDeductionSystem: (year: string, month: string, employeeIds: string[]) => {
  return api.post(
    `/salary/re-calculate_no_deduction/system-tracking?year=${year}&month=${month}`,
    { id: employeeIds }
  );
},


  // Get Approved Salary - POST API
  getApprovedSalaries: (year: string, month: string, employeeIds: string[] = []) => {
    return api.post<ApprovalResponse>(
      `/salary/get_approved_salary?year=${year}&month=${month}`,
      { id: employeeIds }
    );
  },

  // Approve Salary - PUT API
  approveSalaries: (year: string, month: string, employeeIds: string[]) => {
    return api.put<ApprovalResponse>(
      `/salary/approved_salary?year=${year}&month=${month}`,
      { id: employeeIds }
    );
  },

  // Get Salary Status - POST API
  getSalaryStatus: (year: string, month: string, employeeIds: string[] = []) => {
    return api.post<SalaryStatusResponse>(
      `/salary/get_salary_status?year=${year}&month=${month}`,
      { id: employeeIds }
    );
  },

  // Reject Salaries (if available)
  rejectSalaries: (year: string, month: string, employeeIds: string[]) => {
    return api.put<ApprovalResponse>(
      `/salary/reject_salary?year=${year}&month=${month}`,
      { id: employeeIds }
    );
  },

 exportEmployees: () => {
  return api.get(`/export_employees`);
},

  // NEW: Export Salary - POST API
  exportSalary: (year: string, month: string, employeeIds: string[] = []) => {
    return api.post<ExportSalaryResponse>(
      `/export_salary?year=${year}&month=${month}`,
      { id: employeeIds }
    );
  },



};